import { AssessmentReportInfo } from '../../../../models/assessmentReportInfo';
var ReviewReportsPageController = /** @class */ (function () {
    /*@ngInject*/
    function ReviewReportsPageController($rootScope, $uibModal, $timeout, DTOptionsBuilder, DTColumnDefBuilder, $filter, StorageService, candidateService, companyService, dateTimeUtilityService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.$timeout = $timeout;
        this.DTOptionsBuilder = DTOptionsBuilder,
            this.DTColumnDefBuilder = DTColumnDefBuilder;
        this.$filter = $filter;
        this.StorageService = StorageService;
        this.candidateService = candidateService;
        this.companyService = companyService;
        this.dateTimeUtilityService = dateTimeUtilityService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    ReviewReportsPageController.prototype.$onInit = function () {
        this.userRole = this.$rootScope.userDetails.roleScreenRef.role.name;
        this.isAuthorizedToAddAndEdit = true;
        this.assessmentReports = [];
        this.companyType = this.$rootScope.userDetails.company.companyType;
        this.actionType = "";
        this.loading = true;
        this._setFilters();
        this.initializeStartAndEndDates();
        this.getAllCandidatesReportDetails();
        this.initTableData();
    };
    ReviewReportsPageController.prototype._setFilters = function () {
        this.filterObject = {
            companyId: this.$rootScope.userDetails.company.companyId,
            searchText: '',
            startDate: this.dateTimeUtilityService.getDateTimeInAPIFormat(moment(new Date()).add(-3, 'M').toDate()),
            endDate: this.dateTimeUtilityService.getDateTimeInAPIFormat(moment(new Date()).add(1, 'd').toDate()),
            isVendorCandidates: false,
            page: '1',
            size: '50000',
            column: null,
            sortDir: 'ASC'
        };
        var previouslySelectedCandidatesTypeVendor = this.StorageService.get('reviewReportsCandidatesTypeVendor');
        if (!_.isNull(previouslySelectedCandidatesTypeVendor) && previouslySelectedCandidatesTypeVendor !== undefined && this.companyType == 'Corporation') {
            this.filterObject.isVendorCandidates = previouslySelectedCandidatesTypeVendor;
        }
        else {
            this.filterObject.isVendorCandidates = false;
        }
        this.StorageService.set('reviewReportsCandidatesTypeVendor', this.filterObject.isVendorCandidates);
    };
    ReviewReportsPageController.prototype.initializeStartAndEndDates = function () {
        var _this = this;
        $(document).ready(function () {
            var currentDate = new Date();
            var startDate = moment(currentDate).add(-3, 'M').toDate();
            var momentOfDefaultEndDateTime = moment(currentDate);
            $('#startDate').datepicker({
                format: "M d, yyyy",
                weekStart: 1,
                autoclose: true
            });
            $("#startDate").datepicker("setDate", startDate);
            $("#startDate").datepicker("update", _this.$filter('fourdotfiveDateFormat')(startDate));
            $('#endDate').datepicker({
                format: "M d, yyyy",
                startDate: startDate,
                weekStart: 1,
                autoclose: true
            });
            $("#endDate").datepicker("setDate", momentOfDefaultEndDateTime.toDate());
            $("#endDate").datepicker("update", _this.$filter('fourdotfiveDateFormat')(momentOfDefaultEndDateTime.toDate()));
            _this.filterObject.startDate = _this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(_this.filterObject.startDateDisplayValue));
            _this.filterObject.endDate = _this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(_this.filterObject.endDateDisplayValue).setHours(23, 59, 59, 999));
            $('#startDate').datepicker().on('changeDate', function (e) {
                _this.filterObject.startDate = _this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(_this.filterObject.startDateDisplayValue));
                _this.filterObject.endDate = _this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(_this.filterObject.endDateDisplayValue).setHours(23, 59, 59, 999));
                _this.getAllCandidatesReportDetails();
            });
            $('#endDate').datepicker().on('changeDate', function (e) {
                _this.filterObject.startDate = _this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(_this.filterObject.startDateDisplayValue));
                _this.filterObject.endDate = _this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(_this.filterObject.endDateDisplayValue).setHours(23, 59, 59, 999));
                _this.getAllCandidatesReportDetails();
            });
        });
    };
    ReviewReportsPageController.prototype.getAllCandidatesReportDetails = function () {
        var _this = this;
        this.loading = true;
        if (this.dtInstance && this.dtInstance.DataTable) {
            this.dtInstance.DataTable.destroy();
        }
        this.companyService.getAllCandidatesReportDetails(this.filterObject, function (data) {
            _this.assessmentReports = _this._massageReportsData(data);
            _this.$timeout(function () {
                _this.loading = false;
            }, 200);
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    ReviewReportsPageController.prototype._massageReportsData = function (reports) {
        angular.forEach(reports, function (report, index) {
            report.reportGeneratedDateUTC = moment(report.reportGeneratedDateTime).tz("UTC").format("MMM D, YYYY");
            report.reportGeneratedTimeUTC = moment(report.reportGeneratedDateTime).tz("UTC").format("h:mm a");
            report.appearedOnDateUTC = moment(report.appearedOn).tz("UTC").format("MMM D, YYYY");
            report.appearedOnTimeUTC = moment(report.appearedOn).tz("UTC").format("h:mm a");
            report.violationType = "";
            if (report.assessmentReportInfoList.length > 0) {
                report.violationType = report.assessmentReportInfoList[report.assessmentReportInfoList.length - 1].type;
            }
        });
        return reports;
    };
    ReviewReportsPageController.prototype.initTableData = function () {
        this.dtInstance = {};
        var backGroundEmptyLabel = 'No Reports Available';
        this.dtOptions = this.DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withOption('order', [1, 'desc'])
            .withOption('bFilter', true)
            .withOption('bLengthChange', false)
            .withOption('bInfo', true)
            .withOption('searching', true)
            .withOption('language', { search: "", searchPlaceholder: 'Search', zeroRecords: backGroundEmptyLabel })
            .withBootstrap();
        this.dtColumns = [
            this.DTColumnDefBuilder.newColumnDef(0),
            this.DTColumnDefBuilder.newColumnDef(1),
            this.DTColumnDefBuilder.newColumnDef(2).notSortable(),
            this.DTColumnDefBuilder.newColumnDef(3).notSortable(),
            this.DTColumnDefBuilder.newColumnDef(4).notSortable(),
            this.DTColumnDefBuilder.newColumnDef(5).notSortable(),
            this.DTColumnDefBuilder.newColumnDef(6).notSortable(),
            this.DTColumnDefBuilder.newColumnDef(7).notSortable(),
            this.DTColumnDefBuilder.newColumnDef(8).notSortable(),
            this.DTColumnDefBuilder.newColumnDef(9).notSortable() //comments
        ];
    };
    ReviewReportsPageController.prototype.onCandidatesTypeChanged = function () {
        this.StorageService.set('reviewReportsCandidatesTypeVendor', this.filterObject.isVendorCandidates);
        this.getAllCandidatesReportDetails();
    };
    ReviewReportsPageController.prototype.editComment = function (report) {
        this.actionType = "edit";
        this.launchActionsModal(report);
    };
    ReviewReportsPageController.prototype.deleteComment = function (report) {
        this.actionType = "delete";
        this.launchActionsModal(report);
    };
    ReviewReportsPageController.prototype.launchActionsModal = function (report) {
        var _this = this;
        var actionType = this.actionType;
        var actionLabel = "";
        if (actionType == "edit") {
            actionLabel = "Edit comment";
            if (report.assessmentReportInfoList.length == 0) {
                report.assessmentReportInfoList.push(new AssessmentReportInfo());
            }
        }
        else if (actionType == "delete") {
            actionLabel = "Delete comment";
        }
        else {
            actionLabel = "View Report";
        }
        this.actionsModal = this.$uibModal.open({
            animation: false,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            windowClass: 'four-dot-five-modal-medium',
            component: 'reviewReportsActionsModal',
            backdrop: 'static',
            resolve: {
                actionType: function () {
                    return actionType;
                },
                actionLabel: function () {
                    return actionLabel;
                },
                assessmentInfo: function () {
                    return report;
                }
            }
        });
        this.actionsModal.result.then(function (callbackObject) {
            if (callbackObject.callbackType == 'refresh') {
                _this.getAllCandidatesReportDetails();
            }
        }, function (dismiss) {
            //do nothing;
        });
    };
    ReviewReportsPageController.prototype.showDeleteConfirmationPopUp = function (report) {
        var _this = this;
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
            message: "Deleting the comment(s) (and any violation) entered.Are you sure to continue?",
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    _this._deleteComment(report);
                }
            }
        });
    };
    ReviewReportsPageController.prototype._deleteComment = function (report) {
        var _this = this;
        var commentId = null;
        this.candidateService.deleteCommentFromCandidateReportDetails(report.candidateAssessmentDetailId, commentId, function (data) {
            _this.getAllCandidatesReportDetails();
            _this.alertsAndNotificationsService.showBannerMessage('The comment(s) (and any violation) entered deleted successfully', 'success');
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    ReviewReportsPageController.prototype.showReport = function (report) {
        this.actionType = "showReport";
        this.launchActionsModal(report);
    };
    return ReviewReportsPageController;
}());
export { ReviewReportsPageController };
ReviewReportsPageController.$inject = ['$rootScope', '$uibModal', '$timeout', 'DTOptionsBuilder', 'DTColumnDefBuilder', '$filter', 'StorageService', 'candidateService', 'companyService', 'dateTimeUtilityService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './review-reports-page.html';
import * as TEMPLATE from 'raw-loader!./review-reports-page.html';
export var ReviewReportsPageComponent = {
    selector: 'reviewReportsPage',
    component: {
        template: TEMPLATE.default,
        // templateUrl: 'app/partials/missioncontrol/reports/reviewReports/review-reports-page.html',
        controller: ReviewReportsPageController
    }
};
//# sourceMappingURL=review-reports-page.component.js.map